import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll instantly to top on route change. `search` is included because
    // filtered listings differ only by query string (e.g. /products?category=a
    // -> ?category=b), and those are full content changes to the user.
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
